import React, { memo, useState } from 'react'
import { Modal } from '@material-ui/core'

import SideMenu from './components/SideMenu'
import { MobileHeader } from './components/MobileHeader'
import { DevelopmentBanner } from './components/DevelopmentBanner'
import { useStyles } from './styles'

interface ProtectedContainerProps {
  title?: string
  subtitle?: string
  children?: React.ReactNode
}
const ProtectedContainerComponent: React.FC<ProtectedContainerProps> = ({ children, title, subtitle }) => {
  const { securityContainer, securityViewContainer, securityTitle, securityMain, modalWrapper, desktopMenuWrapper } =
    useStyles()

  const [isMenuOpen, setIsMenuOpen] = useState(false)

  const handleToggleMenu = () => {
    setIsMenuOpen((prev) => !prev)
  }

  const handleClose = () => {
    setIsMenuOpen(false)
  }

  if (!children) return null

  return (
    <div className={securityContainer}>
      <MobileHeader onMenuToggle={handleToggleMenu} />

      {/* Modal para mobile */}
      <Modal open={isMenuOpen} onClose={handleClose} disableBackdropClick>
        <div className={modalWrapper}>
          <SideMenu close={handleClose} isOpen={isMenuOpen} />
        </div>
      </Modal>

      {/* Menu desktop */}
      <div className={desktopMenuWrapper}>
        <SideMenu close={handleClose} isOpen={false} />
      </div>

      <div className={securityViewContainer}>
        <main id='main-container' className={securityMain}>
          {title && <h1 className={securityTitle}>{`${title}${subtitle ? ` > ${subtitle}` : ''}`}</h1>}
          {children}
        </main>
        <DevelopmentBanner />
      </div>

    </div>
  )
}

export const ProtectedContainer = memo(ProtectedContainerComponent)
